import React, { useEffect } from "react";
import GettingStartedWelcomeSection from "../../components/gettingStarted/GettingStartedWelcomeSection";
import { useSelector } from "react-redux";
import { getsubDomain, isCustomerSite } from "../../utils/getsubDomain";
import { useLocation, useNavigate } from "react-router-dom";
import PendingTeamTasks from "../../components/tasks/PendingTeamTasks";
import LoggerGate from "../../components/logger/LoggerGate";
// import PendingTasks from "../../components/gettingStarted/PendingTasks";
// import GuideCTA from "../../components/gettingStarted/GuideCTA";
// import PendingTasks from "../Dashboard/PendingTasks";
// import { getTestLevel } from "../../utils/testLevel";
// import { def } from "../../config";
// import GettingStartedVideoModal from "../../components/modal/GettingStartedVideoModal";
// import { cards } from "../../components/ProfileSurvey/New/ProfileStatusCheck";
// import Card from "../../components/DIsplay/Card";
// import Overview from "../Dashboard/Overview";

function GettingStartedHome() {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user.userData);
  // const subdomain = getsubDomain();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const redirect = searchParams.get("redirect");

  const customer = isCustomerSite();

  const handleExplore = () => {
    navigate("/welcome/pricing");
  };

  useEffect(() => {
    if (customer) navigate(redirect || "/order/new/flight");
  }, []);

  if (customer) return null;

  return (
    <div className="w-full px-4 lg:px-10 py-10 flex flex-col flex-1 font-main bg-[#F8F8F8]">
      {/* <GettingStartedVideoModal /> */}
      {/* <div className="w-full flex justify-between">
        <div>
          {user?.guideStep !== "done" && (
            <span className="font-bold text-xl lg:text-3xl">
              Getting started
            </span>
          )}
        </div>
        {user?.detail?.isVerified && (
          <button
            className="text-sm lg:text-base text-[#2DA771] bg-[#80EFDF]/60 rounded-lg px-4 py-2 "
            onClick={handleExplore}
          >
            Explore plans
          </button>
        )}
      </div> */}
      {/* <GuideCTA /> */}
      <GettingStartedWelcomeSection />
      <div className="mt-8">
        <LoggerGate />
      </div>
      {/* taks here */}
      {/* <PendingTasks /> */}
      <div className="mt-8"></div>
      {user?.userType === "Staff" ? <PendingTeamTasks /> : null}
      {/* <Overview /> */}
      {/* <PendingTasks /> */}
      {/* {user?.detail?.isVerified ? 
        <div className="flex gap-6 flex-wrap md:flex-nowrap">
          {cards.map((card, i) => (
            <Card
            obj={card}
            key={i}
            className={`duration-${(i + 1) * 2 * 100}`}
            />
          ))}
        </div>
      :null} */}
    </div>
  );
}

export default GettingStartedHome;

const Classname = {
  container: "",
};
